import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useHydratedSession } from '#/lib/auth-client'

/** Account-independent query keys must not retain another account's private response. */
export function SessionCacheBoundary() {
  const { data, isPending } = useHydratedSession()
  const previousUser = useRef<string | null | undefined>(undefined)
  const queryClient = useQueryClient()
  useEffect(() => {
    if (isPending) return
    const userId = data?.user.id ?? null
    if (previousUser.current !== undefined && previousUser.current !== userId) {
      void queryClient.cancelQueries()
      queryClient.clear()
    }
    previousUser.current = userId
  }, [data?.user.id, isPending, queryClient])
  return null
}
